 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~about-franchise-about-franchise-module~home-home-module~order-food-online-order-food-online-~5d91560d":"default~about-franchise-about-franchise-module~home-home-module~order-food-online-order-food-online-~5d91560d","default~home-home-module~order-food-online-order-food-online-module~sawai-resort-sawai-resort-module":"default~home-home-module~order-food-online-order-food-online-module~sawai-resort-sawai-resort-module","sawai-resort-sawai-resort-module":"sawai-resort-sawai-resort-module","default~admin-admin-module~login-login-module~resort-home-resort-home-module":"default~admin-admin-module~login-login-module~resort-home-resort-home-module","admin-admin-module":"admin-admin-module","sawai-veg-sawai-veg-module":"sawai-veg-sawai-veg-module","about-us-about-us-module":"about-us-about-us-module","activities-activities-module":"activities-activities-module","business-opportunities-business-opportunities-module":"business-opportunities-business-opportunities-module","cancellation-policy-cancellation-policy-module":"cancellation-policy-cancellation-policy-module","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~2ae62b6b":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~2ae62b6b","login-login-module":"login-login-module","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~3ba970c9":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~3ba970c9","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~db855625":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~db855625","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~9299e4e5":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~9299e4e5","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~db0c4b6c":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~db0c4b6c","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~caf48393":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~caf48393","default~add-edit-villa-add-villa-add-villa-module~all-invoices-all-invoice-module~mark-a-special-day~1bf1088b":"default~add-edit-villa-add-villa-add-villa-module~all-invoices-all-invoice-module~mark-a-special-day~1bf1088b","default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~gallery-galle~f46bda92":"default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~gallery-galle~f46bda92","default~about-franchise-about-franchise-module~add-edit-villa-add-villa-add-villa-module~banners-add~72483754":"default~about-franchise-about-franchise-module~add-edit-villa-add-villa-add-villa-module~banners-add~72483754","default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~incentives-in~d17a4876":"default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~incentives-in~d17a4876","default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~incentives-in~543c819d":"default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~incentives-in~543c819d","reservation-reservation-module":"reservation-reservation-module","default~resort-home-resort-home-module~villas-and-rates-villas-and-rates-module":"default~resort-home-resort-home-module~villas-and-rates-villas-and-rates-module","villas-and-rates-villas-and-rates-module":"villas-and-rates-villas-and-rates-module","default~dashboard-dashboard-module~nearby-attractions-nearby-attractions-module~register-register-mo~7899795c":"default~dashboard-dashboard-module~nearby-attractions-nearby-attractions-module~register-register-mo~7899795c","resort-home-resort-home-module":"resort-home-resort-home-module","user-profile-user-profile-module":"user-profile-user-profile-module","register-register-module":"register-register-module","gallery-gallery-module":"gallery-gallery-module","default~all-bookings-all-bookings-module~contact-us-contact-us-module~veg-contact-us-veg-contact-us-module":"default~all-bookings-all-bookings-module~contact-us-contact-us-module~veg-contact-us-veg-contact-us-module","default~contact-us-contact-us-module~veg-contact-us-veg-contact-us-module":"default~contact-us-contact-us-module~veg-contact-us-veg-contact-us-module","contact-us-contact-us-module":"contact-us-contact-us-module","privacy-policy-privacy-policy-module":"privacy-policy-privacy-policy-module","terms-and-conditions-terms-and-conditions-module":"terms-and-conditions-terms-and-conditions-module","mark-a-special-day-mark-a-special-day-module":"mark-a-special-day-mark-a-special-day-module","default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~d2b8c74e":"default~add-edit-villa-add-villa-add-villa-module~add-edit-villa-all-villa-list-all-villa-list-modul~d2b8c74e","add-edit-villa-all-villa-list-all-villa-list-module":"add-edit-villa-all-villa-list-all-villa-list-module","banners-all-banner-list-all-banner-list-module":"banners-all-banner-list-all-banner-list-module","customer-feedback-customer-feedback-module":"customer-feedback-customer-feedback-module","default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~incentives-in~7c65c8f7":"default~add-edit-villa-add-villa-add-villa-module~banners-add-banner-add-banner-module~incentives-in~7c65c8f7","add-edit-villa-add-villa-add-villa-module":"add-edit-villa-add-villa-add-villa-module","default~all-bookings-all-bookings-module~all-invoices-all-invoice-module~users-users-module":"default~all-bookings-all-bookings-module~all-invoices-all-invoice-module~users-users-module","all-invoices-all-invoice-module":"all-invoices-all-invoice-module","packages-packages-module":"packages-packages-module","banners-add-banner-add-banner-module":"banners-add-banner-add-banner-module","default~incentives-incentives-rates-add-incentives-rates-add-module~notifications-add-notification-a~c2d3dcea":"default~incentives-incentives-rates-add-incentives-rates-add-module~notifications-add-notification-a~c2d3dcea","notifications-add-notification-add-notification-module":"notifications-add-notification-add-notification-module","incentives-incentives-days-incentives-days-module":"incentives-incentives-days-incentives-days-module","all-bookings-all-bookings-module":"all-bookings-all-bookings-module","dashboard-dashboard-module":"dashboard-dashboard-module","nearby-attractions-nearby-attractions-module":"nearby-attractions-nearby-attractions-module","incentives-incentives-rates-add-incentives-rates-add-module":"incentives-incentives-rates-add-incentives-rates-add-module","incentives-incentives-all-incentives-all-module":"incentives-incentives-all-incentives-all-module","incentives-incentives-rates-incentives-rates-module":"incentives-incentives-rates-incentives-rates-module","magic-moments-magic-moments-module":"magic-moments-magic-moments-module","notifications-all-notification-list-all-notification-list-module":"notifications-all-notification-list-all-notification-list-module","properties-properties-module":"properties-properties-module","stay-benefits-stay-benefits-module":"stay-benefits-stay-benefits-module","users-user-details-user-details-module":"users-user-details-user-details-module","users-users-module":"users-users-module","resort-gallery-resort-gallery-module":"resort-gallery-resort-gallery-module","default~about-franchise-about-franchise-module~home-home-module~order-food-online-order-food-online-~99691091":"default~about-franchise-about-franchise-module~home-home-module~order-food-online-order-food-online-~99691091","default~about-franchise-about-franchise-module~home-home-module~order-food-online-order-food-online-module":"default~about-franchise-about-franchise-module~home-home-module~order-food-online-order-food-online-module","about-franchise-about-franchise-module":"about-franchise-about-franchise-module","home-home-module":"home-home-module","veg-contact-us-veg-contact-us-module":"veg-contact-us-veg-contact-us-module","order-food-online-order-food-online-module":"order-food-online-order-food-online-module","veg-user-profile-veg-user-profile-module":"veg-user-profile-veg-user-profile-module","shipping-and-refund-policy-shipping-and-refund-policy-module":"shipping-and-refund-policy-shipping-and-refund-policy-module","veg-privacy-policy-veg-privacy-policy-module":"veg-privacy-policy-veg-privacy-policy-module","veg-terms-and-conditions-veg-terms-and-conditions-module":"veg-terms-and-conditions-veg-terms-and-conditions-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
